import {industryGroupFilter, IndustryGroupFilter} from "./filters/IndustryGroupFilter";
import {IndustryGroupTranslateFilter, industryGroupTranslateFilter} from "./filters/IndustryGroupTranslateFilter";

export default function(parentModule: string): string {
    const moduleName = `${parentModule}.industry-group`;
    return angular.module(moduleName, [])
                  .filter(IndustryGroupFilter, industryGroupFilter)
                  .filter(IndustryGroupTranslateFilter, industryGroupTranslateFilter)
                  .name;
}